export default class UploadedFileSave {
    constructor() {

        this.fileName = '';
        this.file = '';
        this.contentType = '';
        this.encoding = ';'

    }
}
